export default {
  id: 'l-1',
  navTitleID: 'l-1.navTitle',
  pages: [
    {
      id: 'page-1',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textID: 'text',
          styling: {
            textAlign: 'center'
          }
        }
      ]
    },
    {
      id: 'page-2',
      components: [
        {
          type: 'video',
          videoSrc: 'KN_123'
        }
      ]
    },
    {
      id: 'page-3',
      components: [
        {
          type: 'image',
          src: '/deltakere/tredeltakere.png',
          alt: 'Bilde av Stefan, Maria & Toralf',
          width: '45rem',
          height: 'auto'
        },
        {
          type: 'text',
          titleID: 'title',
          textID: 'text',
          styling: {
            textAlign: 'center'
          }
        }
      ]
    },
    {
      id: 'page-4',
      components: [
        {
          type: 'mc-standard',
          questionID: 'question',
          instructionID: 'instruction',
          hintID: 'hint',
          rightFeedbackID: 'feedback-right',
          wrongFeedbackID: 'feedback-wrong',
          options: [
            {
              isCorrect: true,
              textID: 'option-1'
            },
            {
              isCorrect: true,
              textID: 'option-2'
            },
            {
              isCorrect: false,
              textID: 'option-3'
            },
            {
              isCorrect: false,
              textID: 'option-4'
            },
            {
              isCorrect: true,
              textID: 'option-5'
            }
          ]
        }
      ]
    }
  ]
}
